module.exports = __webpack_public_path__ + "static/media/fac4.0c32018a.jpg";